module.exports = __webpack_public_path__ + "70d70fac53081255c2dc3e0e91a082aa.MP3";